import { Component, OnInit, AfterViewInit, AfterViewChecked, ElementRef, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import * as AOS from 'aos';
import * as $ from 'jquery';
import { AuthService } from './services/auth.service';
import { ViewportScroller } from '@angular/common';
import { SeoService } from 'src/app/services/seo.service';
import { Router, NavigationEnd, NavigationStart, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';

declare var jQuery: Function;
declare let dataLayer: any[];
declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit, AfterViewChecked {
  title = 'Reachr';
  trackingCode = environment.google_analytics;

  constructor(private authService: AuthService, private scroll: ViewportScroller, private router: Router, private activatedRoute: ActivatedRoute,
    private seoService: SeoService, @Inject(PLATFORM_ID) private readonly platformId: Object, private readonly renderer: Renderer2,
    private readonly el: ElementRef, private Location: Location) {

    this.router.events.subscribe(event => {
      //console.log(event);

      if (isPlatformBrowser(this.platformId)) {
        if (event instanceof NavigationEnd) {
          if (!!event.url && event.url.match(/^\/#/)) {
            this.router.navigate([event.url.replace('/#', '')]);
          }

          gtag('config', this.trackingCode,
            {
              'page_path': event.urlAfterRedirects
            });
        }
      }
    });

    this.redirectLoginLinkedin();
    this.redirectLoginAzure();

    // BROWSER
    if (isPlatformBrowser(this.platformId)) {
      const script = this.renderer.createElement('script') as HTMLScriptElement;
      script.src = `//www.googletagmanager.com/gtag/js?id=${this.trackingCode}`;
      script.async = true;
      this.renderer.appendChild(this.el.nativeElement, script);

      const script2 = this.renderer.createElement('script') as HTMLScriptElement;
      const scriptBody = this.renderer.createText(`
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());

        gtag('config', '${this.trackingCode}');
      `);
      this.renderer.appendChild(script2, scriptBody);
      this.renderer.appendChild(this.el.nativeElement, script2);
    }
  }

  ngOnInit(): void {
    // BROWSER
    if (isPlatformBrowser(this.platformId)) {

      AOS.init();

      dataLayer.push({ 'event': 'optimize.activate' });

      if ($('#preloader').length) {
        $('#preloader').delay(100).fadeOut('slow', function () {
          $(this).remove();
        });
      }
    }

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data),
    ).subscribe(data => {
      //console.log(data)
      let seoData = data['seo'];
      this.seoService.updateTitle(seoData['title']);
      this.seoService.updateMetaTags(seoData['metaTags']);
    });

    this.showTermsCoookieAfterThreeMonth();

    this.isAutoAuth();
    this.capturarVideoEntrevista();
  }

  ngAfterViewInit(): void {
    this.authService.initFacebook();

  }

  ngAfterViewChecked(): void {
    this.mostrarEsconderPipedrive();
  }

  isAutoAuth() {
    this.activatedRoute.queryParams.subscribe(params => {
      console.log(params);
      if (params['email'] && params['password']) {
        let data = {
          userName: params['email'],
          password: params['password']
        }
        localStorage.setItem("isExibirTutorial", "true");
        this.authService.login(data, {}).subscribe(res => {
          console.log(res);
        });
      }
    });
  }

  // Captura o token da vídeo entrevista vindo do link do e-mail
  // (?video-entrevista=TOKEN) e guarda no localStorage. Após o login, a dashboard
  // do candidato (mesma origem) lê esse token e redireciona para a realização.
  capturarVideoEntrevista() {
    this.activatedRoute.queryParams.subscribe(params => {
      const token = params['video-entrevista'];
      if (token) {
        localStorage.setItem('ls.videoEntrevistaToken', token);
      }
    });
  }

  mostrarEsconderPipedrive(): void {
    // BROWSER
    if (isPlatformBrowser(this.platformId)) {
      if (this.router.url.includes('vaga') == true || this.router.url.includes('candidato') == true) {
        if (document.getElementById('LeadboosterContainer') != undefined) {
          document.getElementById('LeadboosterContainer').style.cssText = 'display:none !important';
        }
      } else {
        if (document.getElementById('LeadboosterContainer') != undefined) {
          document.getElementById('LeadboosterContainer').style.cssText = 'display:block !important';
        }
      }
    }
  }

  redirectLoginLinkedin() {
    const url = window.location.href;
    console.log('[LinkedIn] redirectLoginLinkedin chamado. URL:', url);
    const hasCode = url.includes('code');
    const hasState = url.includes('state');
    const hasQuery = url.includes('?');
    console.log('[LinkedIn] hasQuery:', hasQuery, '| hasCode:', hasCode, '| hasState:', hasState);
    if (hasQuery && hasCode && hasState) {
      console.log('[LinkedIn] Condição OK — chamando loginLinkedin');
      this.authService.loginLinkedin(url);
    } else {
      console.log('[LinkedIn] Condição NÃO atendida — login não disparado');
    }
  }

  redirectLoginAzure() {
    const url = window.location.href;
    if (url.includes('?') && url.includes('azureCode') && url.includes('emp')) {
      this.authService.loginAzure(url);
    }
  }

  scrollToTop() {
    this.scroll.scrollToPosition([0, 0]);
  }

  showTermsCoookieAfterThreeMonth() {
    // BROWSER
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('termo-aceito-em')) {
        var dataAceite = new Date(parseInt(localStorage.getItem('termo-aceito-em')));
        var timeDiff = Math.abs(dataAceite.getTime() - Date.now());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        if (diffDays <= 90) {
          document.getElementById("banner-cookie").style.display = "none";
          document.getElementById("backTop").style.display = "block";
        } else {
          document.getElementById("banner-cookie").style.display = "block";
          document.getElementById("backTop").style.display = "none";
        }
      } else {
        document.getElementById("banner-cookie").style.display = "block";
      }
    }
  }

  hideCookies(aceito: boolean) {
    // BROWSER
    if (isPlatformBrowser(this.platformId)) {
      // As telas de login não têm o header do site.
      const header = document.getElementById("header");
      if (header) {
        header.style.top = "0";
      }
      document.getElementById("banner-cookie").style.display = "none";
      document.getElementById("backTop").style.display = "block";
      if (aceito) {
        localStorage.setItem('termo-aceito-em', Date.now().toString());
      }
    }
  }
  showTermsCookies() {
    jQuery("#modalCookie").modal("show");
  }
}

